import type { AlgebraKey } from './keys';

export const nl: Partial<Record<AlgebraKey, string>> = {
  'app.title': 'Algebra',
  'app.eyebrow': 'Wiskunde · Algebra',
  'app.tagline': 'Los op, ontbind in factoren, vereenvoudig en los op.',
  'app.panel.heading': 'Algebra',
  'panel.experiment': 'Experiment',
  'panel.enter-number': 'Voer een uitdrukking of vergelijking in',
  'panel.show-sigma-stack': 'Toon stapelsom',
  'panel.show-closed-form': 'Toon gesloten vorm',
  'panel.show-sign-chart': 'Toon tekenschema',
  'label.system': 'Stelsel',
  'label.solution': 'Oplossing',
  'label.steps': 'Stappen',
  'hint.line1': 'Kies een experiment, manipuleer de uitdrukkingen, bekijk de algebra veranderen.',
  'hint.line2': 'Educatieve inhoud leeft in de regels van algebra, niet in de tekst.',
  // 8 Experiments
  'experiment.equation-balance.label': 'Vergelijking balanceren',
  'experiment.equation-balance.info':
    'Los vergelijkingen op door beide kanten in evenwicht te houden',
  'experiment.factor-tiles.label': 'Factortegels',
  'experiment.factor-tiles.info': 'Ontbind polynomen in factoren door tegels in te schikken',
  'experiment.quadratic-workshop.label': 'Kwadratisch werkshop',
  'experiment.quadratic-workshop.info':
    'Los kwadratische vergelijkingen op drie manieren op: ontbinden in factoren, kwadraatafsplitsing en de abc-formule',
  'experiment.polynomial-arithmetic.label': 'Polynoomrekenen',
  'experiment.polynomial-arithmetic.info': 'Vermenigvuldig en deel polynomen',
  'experiment.systems-laboratory.label': 'Stelsellaboratorium',
  'experiment.systems-laboratory.info': 'Los stelsels van lineaire vergelijkingen op',
  'experiment.inequality-line.label': 'Ongelijkheidsgetallenlijn',
  'experiment.inequality-line.info': 'Los ongelijkheden op en visualiseer ze op een getallenlijn',
  'experiment.sequences-staircase.label': 'Rijentrap',
  'experiment.sequences-staircase.info': 'Verken rekenkundige en meetkundige rijen',
  'experiment.expression-rewriter.label': 'Uitdrukkingsherschrijver',
  'experiment.expression-rewriter.info': 'Pas algebraregels toe om uitdrukkingen te vereenvoudigen',
  // Operations
  'op.add-both-sides': 'Tel bij beide kanten op',
  'op.subtract-both-sides': 'Trek van beide kanten af',
  'op.multiply-both': 'Vermenigvuldig beide zijden',
  'op.divide-both': 'Deel beide zijden',
  'op.square-both': 'Kwadrateer beide zijden',
  'op.cross-multiply': 'Kruislings vermenigvuldigen',
  // Methods
  'method.factoring': 'Ontbinden in factoren',
  'method.completing-square': 'Kwadraatafsplitsing',
  'method.quadratic-formula': 'abc-formule',
  'method.substitution': 'Substitutie',
  'method.elimination': 'Eliminatie',
  'method.rational-root-theorem': 'Stelling van rationale wortels',
  'method.special-products': 'Bijzondere producten',
  // Rewriter rules
  'rule.distribute': 'Haakjes wegwerken',
  'rule.collect-like-terms': 'Gelijksoortige termen verzamelen',
  'rule.factor-common-monomial': 'Gemeenschappelijke eenterm buiten haakjes halen',
  'rule.cancel-common-factor': 'Gemeenschappelijke factor schrappen',
  'rule.simplify-fraction': 'Breuk vereenvoudigen',
  'rule.flatten-add': 'Optelling plat maken',
  'rule.flatten-mul': 'Vermenigvuldiging plat maken',
  'rule.exponent-product': 'Product van exponenten',
  'rule.exponent-power': 'Macht van een macht',
  'rule.exponent-quotient': 'Quotient van exponenten',
  'rule.negative-exponent': 'Negatieve exponent',
  'rule.zero-exponent': 'Exponent nul',
  'rule.log-product': 'Logaritme productregel',
  'rule.log-power': 'Logaritme machtsverheffing',
  'rule.log-quotient': 'Logaritme quotiëntregel',
  'rule.change-of-base': 'Verandering van grondtal',
  'rule.radical-to-frac-exp': 'Radicaal naar fractionele exponent',
  'rule.frac-exp-to-radical': 'Fractionele exponent naar radicaal',
  'rule.rationalize-denominator': 'Noemer rationaliseren',
  'rule.multiply-by-conjugate': 'Vermenigvuldig met geconjugeerde',
  // Solution kinds
  'kind.unique': 'Unieke oplossing',
  'kind.inconsistent': 'Strijdig',
  'kind.dependent': 'Afhankelijk',
  'kind.extraneous': 'Vreemde oplossing',
  'kind.consistent-unique': 'Consistent en uniek',
  'kind.no-real-roots': 'Geen reële wortels',
  'kind.complex-pair': 'Complexe wortels',
  'systems.no-solution': 'Geen oplossing (strijdig)',
  'systems.infinitely-many': 'Oneindig veel oplossingen (afhankelijk)',
  // Sequence classes
  'class.arithmetic': 'Rekenkundige rij',
  'class.geometric': 'Meetkundige rij',
  'class.recurrence': 'Recurrentie',
  'class.convergent': 'Convergent',
  'class.divergent': 'Divergent',
  'class.telescoping': 'Telescopering',
  // Steps
  'step.add': 'Optellen',
  'step.subtract': 'Aftrekken',
  'step.multiply': 'Vermenigvuldigen',
  'step.divide': 'Delen',
  'step.distribute': 'Haakjes wegwerken',
  'step.collect-like-terms': 'Gelijksoortige termen verzamelen',
  'step.cross-multiply': 'Kruislings vermenigvuldigen',
  'step.square-both': 'Beide zijden kwadrateren',
  'step.factor': 'Ontbinden in factoren',
  'step.quadratic-formula': 'Pas abc-formule toe',
  'step.isolate-variable': 'Isoleer variabele',
  'step.extraneous-root-removed': 'Vreemde oplossing verwijderd',
  'step.factor-gcd': 'GGD buiten haakjes halen',
  'step.factor-rational-root': 'Ontbind met rationale wortel',
  'step.factor-grouping': 'Ontbind door groepering',
  'step.factor-difference-of-squares': 'Ontbind als verschil van kwadraten',
  'step.factor-sum-of-cubes': 'Ontbind als som van derdemachten',
  'step.factor-difference-of-cubes': 'Ontbind als verschil van derdemachten',
  'step.factor-perfect-square': 'Ontbind als perfect kwadraat',
  'step.factor-special-product': 'Ontbind met bijzonder product',
  'step.factor-quadratic-formula': 'Ontbind met abc-formule',
  'step.factor-irreducible': 'Onreducibel over rationale getallen',
  'step.system-substitute': 'Vervang',
  'step.system-row-swap': 'Wissel rijen',
  'step.system-row-scale': 'Vermenigvuldig rij',
  'step.system-row-add': 'Tel rij bij rij op',
  'step.inequality-move-to-one-side': 'Breng naar één kant',
  'step.inequality-factor': 'Ontbind in factoren',
  'step.inequality-critical-points': 'Vind kritieke punten',
  'step.inequality-asymptotes': 'Vind asymptoten',
  'step.inequality-sign-chart': 'Maak tekenverloop',
  'step.inequality-read-intervals': 'Lees oplossingsintervallen',
  // Buttons
  'btn.reset': 'Opnieuw',
  'btn.reset-view': 'Weergave herstellen',
  'btn.randomise': 'Willekeurig',
  'btn.advanced': 'Geavanceerd',
  'btn.auto-arrange': 'Automatisch rangschikken',
  'btn.check-equivalent': 'Controleer equivalent',
  'btn.undo': 'Ongedaan maken',
  'btn.swap': 'Wissel P ↔ Q',
  // Messages
  'message.parse-error.unexpected-token': 'Onverwacht teken',
  'message.parse-error.unknown-variable': 'Onbekende variabele',
  'message.parse-error.not-a-polynomial': 'Geen polynoom',
  'message.no-real-solutions': 'Geen reële oplossingen',
  'message.extraneous-root-removed': 'Vreemde oplossing verwijderd',
  'message.dividing-by-zero-blocked': 'Kan niet door nul delen',
  'message.target-form-reached': 'Doelvorm bereikt',
  // Equation balance
  'balance.solved': 'Opgelost!',
  'balance.not-tileable':
    'Tegels hebben kleine gehele coëfficiënten nodig — pas de vergelijking aan of randomiseer.',
  // Factor tiles headline
  'factor.irreducible': 'onherleidbaar over ℚ',
  'special.difference-of-squares': 'Speciaal product: verschil van kwadraten',
  'special.perfect-square': 'Speciaal product: volkomen kwadraat',
  'special.sum-of-cubes': 'Speciaal product: som van kubussen',
  'special.difference-of-cubes': 'Speciaal product: verschil van kubussen',
};
